import { EditerExecutionAttributionAutoModel, JournalDto } from 'src/graphql/generated-types';
import { AllocationEdition } from 'src/app/_shared/services/allocations/detail/allocation.service';

const stateName = '[VirtualWalletAllocation] ';

export class VirtualWalletAllocationGetAction {
    static type = stateName + 'get Contribution';
    constructor(public allocationId?: number) {
    }
}

export class VirtualWalletAllocationLoadRelatedListAction {
    static type = stateName + 'load related list';
}

export class VirtualWalletAllocationSaveAction {
    static type = stateName + 'save Contribution';

    constructor(public model: AllocationEdition) {
    }
}

export class VirtualWalletAllocationSaveAutomatedExecutionAction {
    static type = stateName + 'save Contribution Automated Execution';

    constructor(public executionModel?: EditerExecutionAttributionAutoModel) {
    }
}

export class VirtualWalletContributionArchiveAction {
    static type = stateName + 'archive Contribution';

    constructor(public allocationId: number) {
    }
}

export class VirtualWalletAllocationReloadListAction {
    static type = stateName + 'reload Allocation list';

    constructor(public allocationId: number = null) {
    }
}
